module.exports = __webpack_public_path__ + "img/pubwechat.63008343.jpg";